import React from "react";
import { useParams } from "react-router-dom";
import { useWorker } from "../context/WorkerContext";
import ReferAndEarnContent from "./ReferAndEarnContent";

// Mounted only under WorkerLayout, so useWorker() is always safe here.
const ReferAndEarn = () => {
  const { workerType } = useParams();
  const { token } = useWorker();

  return <ReferAndEarnContent token={token} workerType={workerType} />;
};

export default ReferAndEarn;